'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdvancedSearchFilter = function (_PureComponent) {
  _inherits(AdvancedSearchFilter, _PureComponent);

  function AdvancedSearchFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvancedSearchFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvancedSearchFilter.__proto__ || Object.getPrototypeOf(AdvancedSearchFilter)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeFilters = function (value, id, type) {
      return function () {
        var onChangeFilters = _this.props.onChangeFilters;

        onChangeFilters({ value: value, id: id, type: type });
      };
    }, _this.renderFilterType = function (filter) {
      switch (filter.type) {
        case 'select-one':
          return _this.renderSelectOneFilter(filter);
        default:
          return null;
      }
    }, _this.renderSelectOneFilter = function (filter) {
      return _react2.default.createElement(
        'div',
        { key: filter.id, className: 'search-bar-advanced-filters-select-one-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'search-bar-advanced-filters-select-one-label' },
          filter.label || ''
        ),
        _react2.default.createElement(
          'div',
          { className: 'search-bar-advanced-filters-select-one' },
          filter.dataset && filter.dataset.length > 0 && filter.dataset.map(function (data, index) {
            return _react2.default.createElement(
              'button',
              { onClick: _this.onChangeFilters(data.value, filter.id, filter.type), key: index, className: (0, _classnames2.default)({ 'search-bar-advanced-filter-button-active': data.value === filter.value }) },
              ' ',
              data.label
            );
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvancedSearchFilter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var filters = this.props.filters;

      return _react2.default.createElement(
        'div',
        { className: 'search-bar-advanced-filters' },
        filters.map(function (filter) {
          return _this2.renderFilterType(filter);
        })
      );
    }
  }]);

  return AdvancedSearchFilter;
}(_react.PureComponent);

exports.default = AdvancedSearchFilter;